import AbstractComponent from './AbstractComponent';
import { OPENED, DROPDOWN_OPEN } from 'core/Classes';

class Dropdown extends AbstractComponent {
	constructor() {
		super(...arguments);
	}

	bind() {
		super.bind();
		this.handleToggleEvent = this.handleToggleEvent.bind(this);
		this.handleContentEvent = this.handleContentEvent.bind(this);
		this.handleTimerEnd = this.handleTimerEnd.bind(this);
	}

	getUI() {
		const ui = super.getUI();
		ui.$toggle = ui.$element.querySelector('.dropdown__toggle');
		ui.$content = ui.$element.querySelector('.dropdown__content');
		return ui;
	}

	events(listen) {
		const listener = listen ? 'addEventListener' : 'removeEventListener';
		this.ui.$toggle[listener]('mouseenter', this.handleToggleEvent);
		this.ui.$toggle[listener]('mouseleave', this.handleToggleEvent);
		this.ui.$content[listener]('mouseenter', this.handleContentEvent);
		this.ui.$content[listener]('mouseleave', this.handleContentEvent);
	}

	handleToggleEvent(event) {
		clearTimeout(this.timer);

		switch (event.type) {
			case 'mouseenter':
				this.isOpen = true;
				break;
			case 'mouseleave':
				this.timer = setTimeout(this.handleTimerEnd, 500);
				break;
		}
	}

	handleContentEvent(event) {
		clearTimeout(this.timer);

		if (event.type === 'mouseleave') {
			this.isOpen = false;
		}
	}

	handleTimerEnd() {
		this.isOpen = false;
	}

	get isOpen() {
		return this._isOpen;
	}

	set isOpen(value) {
		this._isOpen = value;
		const action = value ? 'add' : 'remove';
		this.ui.$element.classList[action](OPENED);
		document.body.classList[action](DROPDOWN_OPEN);
	}
}

export default Dropdown;
